import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  ref: "editorBox"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Draw = _resolveComponent("Draw");
  const _component_Error = _resolveComponent("Error");
  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_1, null, 512), $options.hasActivityInfo ? (_openBlock(), _createBlock(_component_Draw, {
    key: 0,
    "update-info": $data.update_info,
    type: $data.update_info.type,
    activity_info: $data.activity_info
  }, null, 8, ["update-info", "type", "activity_info"])) : _createCommentVNode("", true)]), $data.showError ? (_openBlock(), _createBlock(_component_Error, {
    key: 0,
    message: $data.showMessage
  }, null, 8, ["message"])) : _createCommentVNode("", true)]);
}